import ajax from './http'

/*****公共接口******/
//获取账号信息
export function getAcconutInfo() {
  return ajax({
    url: "/system/users/getAccountInfo",
    type: "GET",
    data: {}
  })
}
//修改账号信息
export function changeAcconutInfo(data) {
  return ajax({
    url: "/system/users/modifyAccount",
    type: "POST",
    data
  })
}
//文件上传
export function uploadFile(formData, onUploadProgress) {
  return ajax({
    url: "/upload/common",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    data: formData
  })
}
//视频上传
export function uploadVideoFile(formData, onUploadProgress) {
  return ajax({
    type: "POST",
    url: "/upload/uploadProductVideo",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    data: formData
  })
}
//oss视频上传
export function uploadOssVideoFile(formData, onUploadProgress) {
  return ajax({
    type: "POST",
    url: "/upload/mulipartV2/pm",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    data: formData
  })
}
/*****首页******/
export function getIndexData(timeType, organizationId) {
  return ajax({
    type: "GET",
    url: `/buz/policy/queryHomeStatistics`,
    data: {
      timeType,
      organizationId
    },
  })
}
// 首页客户成交统计
export function getHolderCount(organizationId) {
  return ajax({
    type: "GET",
    url: `/buz/holder/getHolderCount`,
    data:{
      organizationId
    }
  })
}
// 首页保单保费统计
export function getAllPolicyStatistics(organizationId) {
  return ajax({
    type: "GET",
    url: `/buz/policy/getAllPolicyStatistics`,
    data:{
      organizationId
    }
  })
}
/*****组织管理******/
//单个机构
export function getOrg() {
  return ajax({
    url: "/buz/organizationBase/read/orgTree",
    type: "POST",
    data: {
      source:1,
    },
  })
}
/*****组织管理******/

/*****机构管理******/
// 获取组织
export function getOrganizationBase(obj) {
  return ajax({
    type: "POST",
    url: `/buz/organizationBase/read/tree`,
    data:{
      source:1,
    }
  })
}
// 获取机构信息
export function getOrganizationInfo(data) {
  return ajax({
    type: "POST",
    contentType: "from",
    url: `/buz/organizationBase/getInfo`,
    data
  })
}

// 获取字典模板
export function getOrganTemplate(code) {
  return ajax({
    type: "post",
    url: "/system/dic/read/dicList",
    data: {
      code,
    },
  })
}
// 手机号搜索
export function organizationBaseSearchByMobile(obj) {
  return ajax({
    type: "GET",
    url: `/buz/organizationBase/search`,
    data: {
      ...obj
    }

  })
}

//机构树形结构
export function getOrgTree() {
  return ajax({
    url: "/buz/organizationBase/read/orgTree",
    type: "POST",
    data: {
      source:1,
    },
  })
}
/*****机构管理******/



/*****商品库******/

//一级标签
export function getFirstTag() {
  return ajax({
    url: "/buz/productTheme/array/first",
    type: "GET",
  })
}
//二级标签
export function getSecondTag(parentId) {
  return ajax({
    url: "/buz/productTheme/array/second",
    type: "GET",
    data: {
      parentId
    }
  })
}

/*****保单管理******/

//保单 统计
export function getInsureStatistics(data) {
  return ajax({
    url: "/buz/policy/statistics",
    type: "POST",
    data
  })
}
//订单详情
export function getOrdeDetail(orderNo) {
  return ajax({
    url: "/buz/order/read/detail",
    type: "GET",
    data: {
      orderNo
    }
  })
}
//订单统计
export function getOrderStatistics(data) {
  return ajax({
    url: "/buz/order/statistics",
    type: "POST",
    data
  })
}

//修改产品
export function productManageEdit(obj) {
  return ajax({
    url: "/buz/productBase/edit",
    type: "POST",
    data: {
      ...obj
    }
  })
}
//查询资料所有类型
export function productManageGetAllType() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "BASIC_MATERIAL"
    }
  })
}

//费用列表
export function getCommissionList(productCode, templateId) {
  return ajax({
    url: "/buz/commission/queryTemplateCommission",
    type: "GET",
    data: {
      productCode,
      templateId
    }
  })
}
//费用模板tab
export function getCommissionTabs(productCode) {
  return ajax({
    url: "/buz/templateProduct/queryTemplate",
    type: "GET",
    data: {
      productCode
    }
  })
}
/*******公告******/
//列表
export function chatMangeList(data) {
  return ajax({
    type: "POST",
    url: `/buz/noticeConfig/queryNewMsgList`,
    data
  })
}
//公告详情
export function chatMangeDetail(id) {
  return ajax({
    type: "GET",
    url: `/buz/noticeConfig/read/msg`,
    data: {
      id
    }
  })
}
//平台公告详情
export function chatPlatNotSyncMangeDetail(platformId) {
  return ajax({
    type: "GET",
    url: `/buz/organizationMessage/read/detail?id=${platformId}`,
  })
}
//查询未读数
export function lookChatReadNum(tabCode) {
  return ajax({
    type: "GET",
    url: `/buz/noticeConfig/queryUnRead`,
    data: {
      tabCode
    }
  })
}
/*******财务管理 商户******/
// 我的导出
export function myExportAll(totalId, commissionPeriod) {
  return ajax({
    type: "GET",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/settlementTotal/settlement/export`,
    data: {
      totalId,
      commissionPeriod
    }
  })
}
//结算函下载
export function downloadInfo(totalId, path) {
  return ajax({
    type: "GET",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/settlementDetail/settleConfirmDownload`,
    data: {
      totalId,
      path
    }
  })
}
//提现记录
//下级机构待结算费用
export function waitWithdrawAfter() {
  return ajax({
    url: "/buz/settlementTotal/getWaitAmount",
    type: "GET",

  })
}

//业务员提现2
export function userCashWithdrawAudit(data) {
  return ajax({
    url: "/buz/userCashWithdrawLog/edit",
    type: "POST",
    data
  })
}
//业务员提现详情
export function serverWithdrawLogDetail(id) {
  return ajax({
    url: "/buz/userCashWithdrawLog/read/detail",
    type: "GET",
    data: {
      id
    }
  })
}
//获取商户可提现金额
export function getAvailableAmountWithdrawLog() {
  return ajax({
    url: "/buz/merchantWithdrawLog/read/getAmount",
    type: "GET",

  })
}